<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3 style="color:#124e91" >UOETSYLRA</h3>
                    <strong><a href="https://uoetsylra.org" target="_blank" rel="noopener" style="color:black">www.uoetsylra.org</a></strong>
                    <br><br>
                    <p style="text-align: justify; font-size: 14px;" style="color:rgb(91, 91, 91)">Se denomina Union Obreros y Empleados Tintoreros, Sombrereros y Lavaderos de la Repùblica Argentina (Uoetsylra), a la entidad gremial de primer grado, fundada el 22 de Septiembre de 1946, adherida al régimen de Asociaciones Sindicales de Trabajadores el 19 de Junio de 1946, con domicilio real y legal en Chile 1571, Ciudad Autónoma de Buenos Aires.</p>
                    <br> <p style="color:black"> © Todos los derechos reservados </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3 style="color:#124e91">Dirección</h3>
                    <ul class="footer-contact-info">
                        <li ><i class='bx bx-map'></i>Culpina 31 - CABA - C1406ENA
                            <br>Buenos Aires - República
                            Argentina
                        </li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3 style="color:#124e91">Nuestras redes</h3>
                    <ul class="footer-contact-info-redes">
                        <li ><a href="https://www.facebook.com/sindicato.uoetsylra" > - Facebook</a></li>
                        <li ><a href="https://www.instagram.com/uoetsylra_oficial" > - Instagram</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p style="color:black"><i class='bx bx-copyright'></i> 2025 Beneficios UOETSYLRA by <a
                            target="_blank"
                            href="https://cipbyte.io/"
                        ><strong style="color:darkorange">CipByte</strong> </a></p>
                </div>
            </div>
        </div>

    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>